export const JWT_TOKEN = "token";
export const CULTURE = "UserCulture";
export const NO_OF_TRIES = "not";
export const LAST_EVENT = "LastEvent";
